import { render, staticRenderFns } from "./UIPagination.vue?vue&type=template&id=1188e6d0"
import script from "./UIPagination.vue?vue&type=script&lang=js"
export * from "./UIPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports